export default function PrivacyPolicy() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Privacy Policy</h2>
      <p>
        Privacy Policy – Nawabi Bites

At Nawabi Bites, we are committed to protecting your personal information.
This Privacy Policy explains how we collect, use and safeguard your data.

Information We Collect

Name

Email and Phone Number

Delivery Address

Payment information (processed securely by payment gateway)

Browsing / cookies data

How We Use Your Information

To process orders

To contact you for delivery updates

To improve our website experience

To prevent fraud and ensure security

Cookies

We use cookies to improve website performance and remember user preferences.

Payment Security

All payments are processed securely through trusted payment processors like Razorpay / PayU / Cashfree.
We do not store your card or UPI details.

Third-Party Sharing

We only share your data with:

Courier partners (for delivery)

Payment gateway (for payments)

We do not sell or rent your personal data.

Your Rights

Request data deletion

Request a copy of your data

Opt-out from marketing emails

Contact

For privacy-related queries:
📩 kumailh553@mail.com
      </p>
    </div>
  );
}
